module.exports = __webpack_public_path__ + "static/media/instagram-icon.c50deb33.svg";